import * as Yup from "yup";

const validationSchema = (schema: any) => {
  const valid = Yup.object({
    otp: Yup.string().required(schema.isRequired),
  });
  return valid;
};

export default validationSchema;
